import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  required,
  BooleanInput
} from "react-admin";
import { FormToolbar } from "../../common/FormToolbar";

export const DepartmentEdit = (props) => {
  return (
    <Edit title="Department Edit" {...props} undoable={false} >
      <SimpleForm toolbar={<FormToolbar {...props} />} variant="outlined">
    
        <TextInput
          source="name"
          fullWidth={true}
          validate={[required()]}
        />
        
        <TextInput
          source="description"
          fullWidth={true}
          validate={[required()]}
        />
        
        <BooleanInput source="isActive" validate={[required()]}  label="Active" initialValue={true}/>
        </SimpleForm>
    </Edit>
  );
};
